/*
 * Geo Header Controller configuration.
 *
 * Showroom behavior:
 * - Orlando = "Showrooms" dropdown containing Orlando + Sarasota.
 * - Every other region = singular "Showroom" direct link.
 *
 * A field set to "TBD" or "VERIFY" is treated as a placeholder.
 * The controller falls back to the default profile where appropriate.
 */

window.GeoHeaderProfiles = Object.freeze({
  default: {
    phoneDisplay: '800-416-4304',
    phoneHref: 'tel:800-416-4304',
    contactUrl: '/pages/contact-us',

    showroomMode: 'link',
    showroomLabel: 'Showroom',
    showroomUrl: null
  },

  seattle: {
    phoneDisplay: '206-743-0116',
    phoneHref: 'tel:12067430116',
    contactUrl: '/pages/seattle-contact-us',

    showroomMode: 'link',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/seattle-kent-washington-massage-chair-showroom'
  },

  orlando: {
    phoneDisplay: '407-768-0975',
    phoneHref: 'tel:14077680975',
    contactUrl: '/pages/orlando-contact-us',

    /*
     * Orlando is the ONLY region that receives the plural
     * Showrooms dropdown.
     */
    showroomMode: 'dropdown',
    showroomLabel: 'Showrooms',
    showroomUrl: '/pages/orlando-florida-massage-chair-showroom',

    showroomMenu: [
      {
        label: 'Orlando',
        url: '/pages/orlando-florida-massage-chair-showroom'
      },
      {
        label: 'Sarasota',
        url: '/pages/sarasota-florida-massage-chair-showroom'
      }
    ]
  },

  sarasota: {
    phoneDisplay: 'VERIFY',
    phoneHref: 'VERIFY',
    contactUrl: '/pages/contact-us',

    /*
     * IMPORTANT:
     * Sarasota must remain a SINGLE showroom link.
     */
    showroomMode: 'link',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/sarasota-florida-massage-chair-showroom'
  },

  atlanta: {
    phoneDisplay: '404-984-2025',
    phoneHref: 'tel:4049842025',
    contactUrl: '/pages/atlanta-contact-us',

    showroomMode: 'link',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/atlanta-georgia-massage-chair-showroom'
  },

  columbia: {
    phoneDisplay: '410-844-0365',
    phoneHref: 'tel:4108440365',
    contactUrl: '/pages/columbia-contact-us',

    showroomMode: 'link',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/columbia-maryland-massage-chair-showroom'
  },

  denver: {
    phoneDisplay: '303-395-1223',
    phoneHref: 'tel:3033951223',
    contactUrl: '/pages/denver-contact-us',

    showroomMode: 'link',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/denver-colorado-massage-chair-showroom'
  },

  houston: {
    phoneDisplay: '713-489-6565',
    phoneHref: 'tel:7134896565',
    contactUrl: '/pages/houston-contact-us',

    showroomMode: 'link',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/houston-texas-massage-chair-showroom'
  },

  gardena: {
    phoneDisplay: '213-452-1564',
    phoneHref: 'tel:2134521564',
    contactUrl: '/pages/gardena-contact-us',

    showroomMode: 'link',
    showroomLabel: 'Showroom',
    showroomUrl: '/pages/los-angeles-gardena-massage-chair-showroom'
  }
});


/*
 * Match priority.
 *
 * Actual territory matching is handled by matchTerritory()
 * inside geo-header-controller.js.
 */
window.GeoHeaderRegionPriority = Object.freeze([
  'seattle',
  'orlando',
  'sarasota',
  'atlanta',
  'columbia',
  'denver',
  'houston',
  'gardena',
  'default'
]);